<template>
  <div>
    <div :class="$isMobile ? 'headersmo' : 'headerspc'">
      <div class="top-box-difl">
        <div class="divimg">
          <!-- @click="$router.push('/getmoney')" -->
          <img src="../assets/img/logo@2x.png" alt="" />
        </div>
        <div class="topnemg-box" v-if="!$isMobile">
          <div
            v-for="item in topnemg"
            :key="item.name"
            class="topnemg-cl"
            @click="$router.push(item.path)"
          >
            <div>{{ item.name }}</div>
          </div>
        </div>

        <div class="top-leir">
          <el-dropdown trigger="click" @command="changeLang">
            <span class="el-dropdown-link">
              <div class="leif-cn">
                <img src="../assets/img/cn.png" alt="" />
                <span>{{ $t("names") }}</span>
              </div>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="en">English(EN)</el-dropdown-item>
              <el-dropdown-item command="zh">中文(CN)</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 
          <div class="leif-search">
            <img src="../assets/img/search.png" alt="" />
          </div>
          <div class="leif-english">
            <img src="../assets/img/english.png" alt="" />
          </div> -->
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topnemg: [
        {
          name: this.$t("nav.about"),
          path: "/",
        },
        {
          name: this.$t("nav.laboratory"),
          path: "/laboratory",
        },
        {
          name: this.$t("nav.product"),
          path: "/product",
        },
        {
          name: this.$t("nav.report"),
          path: "/report",
        },
        {
          name: this.$t("nav.contact"),
          path: "/contact",
        },
      ],
    };
  },

  mounted() {},
  methods: {
    changeLang(lang) {
      let targetLang = lang;
      this.$i18n.locale = targetLang;
      localStorage.setItem("lang", targetLang);
    },
  },
};
</script>

<style lang="scss" scoped>
// 引入外部PC样式文件
@import "@/assets/style/headerspc.scss";
</style>
<style lang="scss" scoped>
// 引入外部移动端样式文件
@import "@/assets/style/headersmo.scss";

// 页面自有局部样式
.detali-hiing {
  padding: 10px;
}
</style>